import Vue from 'vue'

export default new Vue ({
    name: 'constants',
    data: function(){
        return {
            API_PATH: {
                LOGIN: '/login',
                LOGOUT: '/logout',

                ARTICLES: '/articles',
                ARTICLES_: '/articles/:id',
                ARTICLES_DUPLICATE: '/articles/copy/:id',
                RELEASED_ARTICLES: '/articles/release_only',

                CATEGORIES: '/categories',
                CATEGORIES_: '/categories/:id',
                SUB_CATEGORIES_: '/sub_categories/:id',

                COLORS: '/colors',

                TAGS: '/tags',
                TAGS_: '/tags/:id',

                USERS: '/users',
                USERS_: '/users/:id',


                IMAGES: '/images',
                IMAGES_: '/images/:id',
                FILES: '/file_upload',
            }
        }
    }
})